<template>
  <div class="head">{{ title }}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => "",
    },
  },
};
</script>

<style scoped>
.head {
  height: 42px;
  background: #fff6f0;
  line-height: 42px;
  text-align: center;
  color: #333333;
  font-size: 20px;
  margin-bottom: 40px;
}
</style>